export default {
  name: 'page-row',
  functional: true,
  props: {
    title: {
      type: String,
      default: ''
    },
    margin: {
      type: Number,
      default: 0
    }
  },
  render(h, { props, children }) {
    return h('div', { class: 'page-row', style: { marginBottom: props.margin + 'em'}}, [
        props.title && h('div', { class: "page-row__title" }, props.title),
        children
      ])
  }
};



// WEBPACK FOOTER //
// ./demo/components/page-row.js